import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";


class About extends Component {

  componentDidMount() {

  }

  render() {
    return (
      <div className={`main-content${wActs.MainLeftStyle(this.props.WebPage)} left`}>
        <SeoHeaders Position={"Top"}/>
        <pre  style={{fontSize: '14px', lineHeight: '14px'}} dangerouslySetInnerHTML={{__html: this.props.MainContent}}></pre>

        <div className="clear"></div>
        <div className="seo-container">
          <h1 className={"h1-top"} style={{marginBottom: "5px"}}>{this.props.WebPage.Page.H1Text}</h1>
        </div>
        <div className="seo-container">
          {(!wActs.isNullOrEmpty(this.props.WebPage.Page.H1TextBlock)) &&
          <p ref={(r) => {this.BottomSeo = r}} className="h1textblock" style={{textAlign: "justify",padding: "10px"}} dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.H1TextBlock}}></p>
          }
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(About);
